<template>
	<div class="auth login">
		<div class="sk-h1 sk-h1--large">Welcome!</div>
		<div class="sk-note sk-note--margin-l">Please login to yout account.</div>
		<form @submit.prevent="validateAndSubmit" class="form-auth">
			<error-box v-if="error" :error="error"/>
			<input-text v-model="model.email" name="login_email" :placeholder="$t('labels.auth.email')" rules="required|email"/>
			<input-password v-model="model.password" autocomplete="current-password" name="login_password" :placeholder="$t('labels.auth.password')" rules="required"/>
			<div class="form-group">
				<button-submit :loading="loading">{{ $t('buttons.auth.login') }}</button-submit>
			</div>
			<router-link class="margin-top" :to="{ name: 'AuthPasswordRequest' }">{{ $t('base.auth.forgot_password') }}</router-link>
			<span>or</span>
			<router-link :to="{ name: 'AuthRegister'}">{{ $t('base.auth.no_account') }}</router-link>
		</form>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ServiceWorker from '@/sw'
export default {
	data () {
		return {
			loading: false,
			model: {
				email: '',
				password: ''
			},
			error: null
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit() {
			this.loading = true
			this.$store.dispatch('clearAll')
			this.$api.auth.login(this, this.model).then(async (response) => {
				this.$log.info('user login', 'auth.login OK', response)()

				const token = response.data.token
				const user = this.parseJwt(token)

				window.localStorage.setItem('token', token)
				window.localStorage.setItem('user', JSON.stringify(user))

				await this.$store.dispatch('GET_USER', { refThis: this, user_uid: user.uid })

				this.$store.dispatch('GET_DISEASES_NAME', this)
				this.$store.dispatch('CHANGE_USER', this.user)
				this.$router.push({ name: 'Dashboard', params: { user_uid: this.currentUserUid } })

				// tmp
				this.$store.dispatch('setAuthenticated', { token, user })
				this.$store.dispatch('getUser', { context: this })

				/*
				this.$root.$emit('show-introduction', user.uid)

				if (this.$route.query.redirect !== undefined) {
					this.$router.push(this.$route.query.redirect)
				} else {
					const account = window.localStorage.getItem('account')
					const selectedAccount = account == user.uid ? window.localStorage.getItem('selectedAccount') || user.uid : user.uid
					this.$router.push({ name: 'Dashboard', params: { user_uid: selectedAccount } })
				}
				*/

				ServiceWorker.register(() => {
					ServiceWorker.setupClient(this)
				})
				this.$store.dispatch('activePushToken', { context: this, token: ServiceWorker.pushToken })
/*
				this.$store.dispatch('setAuthenticated', { token, user })
				this.$store.dispatch('getUser', { context: this })

				// Register serviceworker
				ServiceWorker.register(() => {
					ServiceWorker.setupClient(this)
				})

				this.$root.$emit('show-introduction', user.uid)

				if (this.$route.query.redirect !== undefined) {
					this.$router.push(this.$route.query.redirect)
				} else {
					const account = window.localStorage.getItem('account')
					const selectedAccount = account == user.uid ? window.localStorage.getItem('selectedAccount') || user.uid : user.uid
					this.$router.push({ name: 'Dashboard', params: { user_uid: selectedAccount } })
				}

				// enable notifications in where
				this.$store.dispatch('activePushToken', { context: this, token: ServiceWorker.pushToken })
*/
			}).catch(errors => {
				// this.$log.error('user login', 'auth.login ERROR', errors)()
				errors.json().then(error => {
					this.$appModal.show({
						error: true,
						title: this.$t(`errors.${error.code}.title`),
						message: this.$t(`errors.${error.code}.message`)
					})
				})
			}).finally(() => {
				this.loading = false
			})
		},
		parseJwt (token) {
			var base64Url = token.split('.')[1]
			var base64 = base64Url.replace('-', '+').replace('_', '/')
			return JSON.parse(window.atob(base64))
		},
	},
	beforeCreate () {
		this.$title(this.$t('base.auth.login'))
	},
	computed: {
		...mapGetters({
			user: 'USER',
			currentUser: 'CURRENT_USER',
			currentUserUid: 'CURRENT_USER_UID',
		})
	},
	created () {
		const isAuthenticated = this.$store.getters.isAuthenticated
		if (isAuthenticated) {
			const userUid = this.$store.state.user.selectedAccount || this.$store.state.user.uid
			this.$router.push({ name: 'Dashboard', params: { user_uid: userUid } })
		}
	}
}
</script>

<style scoped>
.margin-top {
	margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/AuthLogin.vue